// Module: team (HANDOFF §3 «الفريق» → /team/*; boards team/attendance--week,
// team/payroll--month, team/member--permissions). Flag erp.team; manager+ by
// default (HANDOFF §3: staff sees appointments, customers, accounts, tasks
// only) OR a staff member the owner gave the team.read switch («عرض الفريق
// والحضور» on the member card) — exactly what erp-core enforces: GET
// /team/members and /team/attendance/shifts sit behind
// auth.RequireCapability(team.read) (Principal.Can is true for manager+) and
// GET /team/attendance returns the full roster to a team.read holder.
//   الحضور والشفتات  /team/attendance            manager+ OR team.read (owner writes)
//   الرواتب          /team/payroll               owner (payroll amounts, §9)
//   الصلاحيات        /team/permissions[/:id]     manager+ (owner edits)
// «الأعضاء» and «النسب والعمولات» have no board → not rendered (rule 3).
// Contract: src/app/module-types.ts.

import { Navigate } from 'react-router-dom';
import { UsersRound } from 'lucide-react';
import { defineModule, gate, type Gate } from '@/app/module-types';

export const TEAM_ROUTES = {
  attendance: '/team/attendance',
  payroll: '/team/payroll',
  permissions: '/team/permissions',
} as const;

/** manager+ OR the team.read switch. Role first: its sentence is the one a refused deep link shows. */
export const TEAM_ACCESS: Gate[] = [{ minRole: 'manager' }, { capability: 'team.read' }];
const read = gate({ anyOf: TEAM_ACCESS });
const manager = gate({ minRole: 'manager' });

export default defineModule({
  key: 'team',
  label: 'الفريق',
  icon: UsersRound,
  flag: 'erp.team',
  minRole: 'staff',
  anyOf: TEAM_ACCESS,
  rail: 'team',
  routes: [
    { path: '/team', element: <Navigate to={TEAM_ROUTES.attendance} replace />, handle: read },
    { path: TEAM_ROUTES.attendance, lazy: async () => ({ Component: (await import('./screens/AttendanceWeek')).default }), handle: read },
    { path: TEAM_ROUTES.payroll, lazy: async () => ({ Component: (await import('./screens/PayrollMonth')).default }), handle: gate({ minRole: 'owner' }) },
    { path: TEAM_ROUTES.permissions, lazy: async () => ({ Component: (await import('./screens/Permissions')).default }), handle: manager },
    { path: `${TEAM_ROUTES.permissions}/:memberId`, lazy: async () => ({ Component: (await import('./screens/Permissions')).default }), handle: manager },
  ],
  menu: [
    { key: 'attendance', label: 'الحضور والشفتات', to: TEAM_ROUTES.attendance, anyOf: TEAM_ACCESS },
    { key: 'payroll', label: 'الرواتب', to: TEAM_ROUTES.payroll, minRole: 'owner' },
    { key: 'permissions', label: 'الصلاحيات', to: TEAM_ROUTES.permissions, minRole: 'manager' },
  ],
});
